package br.com.texeratx.boardgametimeapp.data.model.game

import kotlinx.serialization.Serializable

@Serializable
data class GameCategoryDTO(
    val id: Long,
    val name: String
)
